"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("iconUtils", function () {
  return {
    /**
     * Try to guess the icon fullname given a short icon.
     * Mostly used because of fontAwesome5, to manage old FA4 namings.
     *
     * Ex:
     * "fab fa-clock" -> "fab fa-clock"
     * "fa-clock" -> "fa fa-clock"
     * "error" -> "tl-ico icon-error"
     */
    getFullName: function getFullName(icon) {
      if (icon == null) {
        return icon;
      }
      var splits = icon.trim().split(" ");
      if (splits.length > 1) {
        return icon;
      }
      if (icon.indexOf("fa-") === 0) {
        return "fa ".concat(icon);
      }
      if (icon.indexOf("icon-") === 0) {
        return "tl-ico ".concat(icon);
      } else {
        return "tl-ico icon-".concat(icon);
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/iconUtils.js
// module id = 2755
// module chunks = 13